import React from 'react';
import ReactDOM from 'react-dom/client';
import '@/index.css';
import { RouterProvider } from 'react-router-dom';
import router from '@/router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import persistorStore from '@/stores';
import { ConfigProvider } from 'antd';
import reportWebVitals from '@/reportWebVitals';
import { theme } from '@/theme/token'
import zhCN from 'antd/locale/zh_CN';
import dayjs from 'dayjs';

import 'dayjs/locale/zh-cn';
dayjs.locale('en');



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    <Provider store={persistorStore.store}>
      <PersistGate loading={null} persistor={persistorStore.persistor}>
        <ConfigProvider locale={zhCN} theme={theme}>
          <RouterProvider router={router} />
        </ConfigProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// 监听浏览器返回，更新面包屑导航数据
const { dispatch } = persistorStore.store;
window.addEventListener('popstate', () => {
  dispatch({
    type: 'POP_MENU_KEYPATH',
    payload: { keyPath: 1, selectedKeys: 1 }
  })
})

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
